import { render, staticRenderFns } from "./TipoApelacion.vue?vue&type=template&id=72024847&"
import script from "./TipoApelacion.vue?vue&type=script&lang=js&"
export * from "./TipoApelacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports